import { useLocation } from 'react-router-dom';

import { usePermissions } from '@/hooks/usePermissions';

import { useScreenActions } from '@/hooks/useScreenActions';

import { resolveResourcePermissions } from '@/utils/permissionEngine';

import type { PageAccess } from '@/config/routeAccessUtils';



/** Page-level action flags — backend screen actions with client permission fallback. */

export function usePageAccess(pathname?: string): PageAccess {

  const location = useLocation();

  const screenPath = pathname ?? location.pathname;

  const actions = useScreenActions(screenPath);

  const { has } = usePermissions();

  const perms = resolveResourcePermissions(screenPath, actions, has);



  return {

    canView: perms.canView,

    canCreate: perms.canCreate,

    canEdit: perms.canEdit,

    canDelete: perms.canDelete,

  };

}

